import React, { useEffect, useState, useCallback, useMemo, useReducer } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Layout from '../../Components/Layout'
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import axios from 'axios';
import { FaStar } from "react-icons/fa";
import { FaMapPin } from "react-icons/fa";
import { useJsApiLoader } from '@react-google-maps/api';
import config from '../../config';
import { FaInfoCircle } from "react-icons/fa";
import { FaDotCircle } from "react-icons/fa";
import { Modal, Button } from "react-bootstrap";
import { ImCross } from "react-icons/im";
import RateCard from '../../Components/Hotel/RateCard';
import { getPrice } from '../../services/priceUtils';
import Swal from 'sweetalert2';
import { useCurrency } from '../../context/CurrencyContext';
import { TiTick } from "react-icons/ti";
import hotelService from '../../services/hotelService';
import BigRateCard from '../../Components/Hotel/BigRateCard';
import { FaShoppingCart, FaTrash } from "react-icons/fa";

const libraries = ["places"];

const HotelGallery = ({ images }) => {
    const sliderOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1,
        dots: false,
        autoplay: true,
        autoplayTimeout: 3000,
    };
    const sliderOptions2 = {
        loop: true,
        margin: 10,
        nav: true,
        dots: false,
        items: 4,
        autoplay: true,
        autoplayTimeout: 1000,
        responsive: {
            0: { items: 2 },
            768: { items: 3 },
            992: { items: 4 },
        },
    };

    // Eğer images array değilse veya boşsa, boş bir array kullan
    const imageList = Array.isArray(images) ? images : [];
    const baseImageUrl = "https://photos.hotelbeds.com/giata/bigger/";

    return (
        <div className="service-wrap mb-4 container">
            <div style={{ width: '100%', height: '480px' }}>
                <OwlCarousel className="service-carousel nav-center mb-4" {...sliderOptions}>
                    {imageList.map((item, index) => (
                        <div key={index} className="service-img">
                            <img 
                                style={{ width: '100%', height: '450px', objectFit: 'cover' }} 
                                src={baseImageUrl + item.path} 
                                className="img-fluid" 
                                alt={`Hotel Image ${index + 1}`}
                                onContextMenu={(e) => e.preventDefault()}
                                onDragStart={(e) => e.preventDefault()}
                            />
                        </div>
                    ))}
                </OwlCarousel>
            </div>
            <div className="slider-nav-thumbnails nav-center">
                <OwlCarousel className="slider-nav-thumbnails" {...sliderOptions2}>
                    {imageList.map((item, index) => (
                        <div key={index}>
                            <img 
                                src={baseImageUrl + item.path} 
                                style={{ width: '100%', height: '150px' }} 
                                className="img-fluid" 
                                alt={`Hotel Thumbnail ${index + 1}`}
                                onContextMenu={(e) => e.preventDefault()}
                                onDragStart={(e) => e.preventDefault()}
                            />
                        </div>
                    ))}
                </OwlCarousel>
            </div>
        </div>
    );
};

const HotelAmenities = ({ facilities = [], showAllFacilities, setShowAllFacilities }) => {
    const visibleFacilities = useMemo(() => 
        showAllFacilities ? facilities : facilities?.slice(0, 15),
        [showAllFacilities, facilities]
    );

    return (
        <div className="border-bottom mb-4 pb-2">
            <h5 className="fs-18 mb-3">Popular Amenities</h5>
            <div className="row">
                {visibleFacilities?.map((item, index) => (
                    <div key={index} className="col-sm-4 col-lg-4">
                        <div className="d-flex align-items-center mb-3">
                            <i className="isax isax-tick-circle5 text-success me-2"></i>
                            <p className="mb-0">{item?.description?.content || 'No description available'}</p>
                        </div>
                    </div>
                ))}
            </div>
            {facilities?.length > 15 && (
                <div className="text-center mt-3">
                    <button 
                        className="btn btn-link p-0 text-primary"
                        onClick={() => setShowAllFacilities(!showAllFacilities)}
                    >
                        {showAllFacilities ? 'See Less' : 'See More'}
                    </button>
                </div>
            )}
        </div>
    );
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'SET_ADULTS':
            return {
                ...state,
                adultCounter: action.payload,
                totalCounter: action.payload + state.childCounter
            };
        case 'SET_CHILDREN':
            return {
                ...state,
                childCounter: action.payload,
                totalCounter: state.adultCounter + action.payload
            };
        case 'SET_CHILDREN_AGES':
            return {
                ...state,
                childrenAges: action.payload
            };
        case 'SET_CHECK_IN':
            return {
                ...state,
                checkIn: action.payload
            };
        case 'SET_CHECK_OUT':
            return {
                ...state,
                checkOut: action.payload
            };
        default:
            return state;
    }
};

export default function Detail() {
    const { search } = useLocation();
    const { code, slug } = useParams();
    const queryParams = new URLSearchParams(search);
    const navigate = useNavigate();
    const [agencyId, setAgencyId] = useState(null);


    console.log('code: ', code);
    // Eğer code veya slug yoksa listeleme sayfasına yönlendir
    useEffect(() => {
        if (!code || !slug) {
            navigate('/hotels');
        }
    }, [code, slug, navigate]);

    
    const [hotelLoading, setHotelLoading] = useState(false);

    // Occupancy bilgileri (URL üzerinden gönderilenler)
    const roomsParam = queryParams.get('rooms');     // Örn: "1,1"
    const adultsParam = queryParams.get('adults');     // Örn: "1,3"
    const childrenParam = queryParams.get('children'); // Örn: "1,2"
    const agesParam = queryParams.get('ages');         // Örn: "8|9-11"

    const [markupValue, setMarkupValue] = useState(0);
    const [selectedRate, setSelectedRate] = useState(null);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    
    // URL'den parametreleri al
    const urlCheckIn = searchParams.get('checkIn');
    const urlCheckOut = searchParams.get('checkOut');
    const urlAdults = parseInt(searchParams.get('adults')) || 2;
    const urlChildren = parseInt(searchParams.get('children')) || 0;
    const urlAges = searchParams.get('ages')?.split('-').map(age => ({ type: 'CH', age: parseInt(age) })) || [];
    const urlNation = searchParams.get('nationality') || localStorage.getItem('nation') || 'TR';

    const [startDate, setStartDate] = useState(urlCheckIn);
    const [endDate, setEndDate] = useState(urlCheckOut);

    const [state, dispatch] = useReducer(reducer, {
        adultCounter: urlAdults,
        childCounter: urlChildren,
        childrenAges: urlAges,
        totalCounter: urlAdults + urlChildren,
        checkIn: urlCheckIn ?? startDate ?? localStorage.getItem('start_date'),
        checkOut: urlCheckOut ?? endDate ?? localStorage.getItem('end_date'),
        loading: false,
        error: null
    });
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: config.API_KEY,
        libraries: libraries
    });
    const [hotel, setHotel] = useState(null);
    const userData = JSON.parse(localStorage.getItem('user_data')); // Kullanıcı verilerini al
    const [showAllFacilities, setShowAllFacilities] = useState(false);
    const visibleFacilities = useMemo(() => 
        showAllFacilities ? hotel?.facilities : hotel?.facilities?.slice(0, 15),
        [showAllFacilities, hotel?.facilities]
    );
    const { selectedCurrency } = useCurrency();
    const [convertedPrices, setConvertedPrices] = useState({});
    const [cancellationPrices, setCancellationPrices] = useState({});

    // Occupancy parametrelerini parse eden yardımcı fonksiyon
    const parseOccupancyParams = (occupanciesStr) => {
        try {
            if (!occupanciesStr) {
                return [{
                    rooms: 1,
                    adults: 2,
                    children: 0,
                    paxes: []
                }];
            }

            const occupancies = JSON.parse(occupanciesStr);
            return occupancies.map(occ => ({
                rooms: occ.rooms || 1,
                adults: occ.adults || 2,
                children: occ.children || 0,
                paxes: occ.paxes?.map(pax => ({
                    type: pax.type || "CH",
                    age: pax.age || 0
                })) || []
            }));
        } catch (error) {
            console.error('Error parsing occupancy params:', error);
            return [{
                rooms: 1,
                adults: 2,
                children: 0,
                paxes: []
            }];
        }
    };

    const fetchHotelDetails = async () => {
        try {
            setHotelLoading(true);
            dispatch({ type: 'setLoading', value: true });

            // URL'den parametreleri al
            const urlParams = new URLSearchParams(window.location.search);
            const urlCode = urlParams.get('code');
            const urlCheckIn = urlParams.get('checkIn');
            const urlCheckOut = urlParams.get('checkOut');
            const urlOccupancies = urlParams.get('occupancies');
            const urlNation = urlParams.get('nationality');

            // Parametreleri doğrula
            if (!urlCode || !urlCheckIn || !urlCheckOut) {
                throw new Error('Missing required parameters');
            }

            // Occupancy parametrelerini parse et
            let occupancies = [];
            try {
                occupancies = urlOccupancies ? JSON.parse(urlOccupancies) : [{
                    rooms: 1,
                    adults: 2,
                    children: 0,
                    paxes: []
                }];
            } catch (error) {
                console.error('Error parsing occupancy params:', error);
                occupancies = [{
                    rooms: 1,
                    adults: 2,
                    children: 0,
                    paxes: []
                }];
            }

            // Availability için request data
            const availabilityRequestData = {
                hotelId: parseInt(urlCode),
                sourceMarket: urlNation || localStorage.getItem('nation') || 'TR',
                checkIn: urlCheckIn,
                checkOut: urlCheckOut,
                occupancies: occupancies,
                boardCodes: [],
                filter: {
                    maxRooms: 10,
                    maxRatePerRoom: 10
                }
            };

            console.log('Availability Request Data:', availabilityRequestData);

            // Önce availability bilgilerini al
            const availabilityResponse = await hotelService.getHotelAvailability(availabilityRequestData);
            console.log('Hotel Availability Data:', availabilityResponse);

            if (availabilityResponse && availabilityResponse.hotel) {
                try {
                    // Sonra content bilgilerini al
                    const contentResponse = await hotelService.getHotelContent(availabilityResponse.hotel.id);
                    console.log('Hotel Content Data:', contentResponse);

                    // İki response'u birleştir
                    if (contentResponse && contentResponse.code === availabilityResponse.hotel.id) {
                        const mergedHotel = {
                            ...availabilityResponse.hotel,
                            // Content'ten gelen veriler
                            name: contentResponse.name?.content || availabilityResponse.hotel.name,
                            description: contentResponse.description?.content || availabilityResponse.hotel.description,
                            address: contentResponse.address || {
                                content: availabilityResponse.hotel.address,
                                street: '',
                                number: ''
                            },
                            city: contentResponse.city || {
                                content: availabilityResponse.hotel.city
                            },
                            country: contentResponse.country || {
                                code: '',
                                isoCode: '',
                                description: {
                                    content: availabilityResponse.hotel.country
                                }
                            },
                            category: contentResponse.category || {
                                code: '',
                                description: {
                                    content: ''
                                }
                            },
                            categoryGroup: contentResponse.categoryGroup || {
                                code: '',
                                description: {
                                    content: ''
                                }
                            },
                            chain: contentResponse.chain || {
                                code: '',
                                description: {
                                    content: ''
                                }
                            },
                            accommodationType: {
                                code: contentResponse.accommodationType?.code || '',
                                typeDescription: contentResponse.accommodationType?.typeDescription || '',
                                typeMultiDescription: contentResponse.accommodationType?.typeMultiDescription || {}
                            },
                            boards: contentResponse.boards || [],
                            facilities: contentResponse.facilities || [],
                            thumbnail: 'https://photos.hotelbeds.com/giata/bigger/' + contentResponse.images?.[0].path || [],
                            image: contentResponse.images || [],
                            web: contentResponse.web || '',
                            phones: contentResponse.phones || [],
                            postalCode: contentResponse.postalCode || '',
                            ranking: contentResponse.ranking || 0,
                            wildcards: contentResponse.wildcards || [],
                            coordinates: contentResponse.coordinates || availabilityResponse.hotel.coordinates,
                            // Availability'den gelen veriler
                            rooms: availabilityResponse.hotel.rooms || [],
                            check_in: availabilityResponse.hotel.check_in,
                            check_out: availabilityResponse.hotel.check_out,
                            nights: availabilityResponse.hotel.nights
                        };
                        setHotel(mergedHotel);
                    } else {
                        setHotel(availabilityResponse.hotel);
                    }
                } catch (err) {
                    console.error(`Error fetching content for hotel ${availabilityResponse.hotel.id}:`, err);
                    setHotel(availabilityResponse.hotel);
                }
            }
        } catch (error) {
            console.error("Detay isteği başarısız oldu:", error);
            Swal.fire({
                title: "Error!",
                text: "Hotel details could not be loaded. Please try again.",
                icon: "error",
                draggable: true,
            });
        } finally {
            setHotelLoading(false);
            dispatch({ type: 'setLoading', value: false });
        }
    };

    useEffect(() => {
        fetchHotelDetails();
        const storedAgencyId = localStorage.getItem('agency_id');
        setAgencyId(storedAgencyId ? Number(storedAgencyId) : null);
    }, []);

    // Fiyat hesaplama useEffect'i
    useEffect(() => {
        const calculatePrices = async () => {
            if (!hotel?.rooms) return;
            
            const userData = JSON.parse(localStorage.getItem('user_data'));
            if (!userData?.token) return;

            const pricePromises = hotel.rooms.map(async (room) => {
                if (!room.rates) return null;
                
                const ratePromises = room.rates.map(async (rate) => {
                    try {
                        // Her rate için benzersiz bir key oluştur
                        const uniqueKey = `${room.code}-${rate.boardCode}-${rate.net}`;
                        const basePrice = rate.net;

                        const [totalPrice, cancellationPrice] = await Promise.all([
                            getPrice(basePrice, userData.token, selectedCurrency, rate.taxes, hotel?.country?.code),
                            rate?.cancellationPolicies?.[0]?.amount ?
                                getPrice(rate.cancellationPolicies[0].amount, userData.token, selectedCurrency) :
                                "0.00"
                        ]);

                        console.log('Rate Price Calculation:', {
                            uniqueKey,
                            basePrice,
                            totalPrice,
                            boardName: rate.boardName,
                            boardCode: rate.boardCode,
                            net: rate.net
                        });

                        return {
                            uniqueKey,
                            total: totalPrice || "0.00",
                            cancellation: cancellationPrice || "0.00",
                            provider: rate.provider
                        };
                    } catch (error) {
                        console.error('Error calculating prices:', error);
                        return {
                            uniqueKey: `${room.code}-${rate.boardCode}-${rate.net}`,
                            total: "0.00",
                            cancellation: "0.00",
                            provider: rate.provider
                        };
                    }
                });
                
                const convertedRates = await Promise.all(ratePromises);
                return {
                    roomCode: room.code,
                    rates: convertedRates
                };
            });
            
            const results = await Promise.all(pricePromises);
            const priceMap = {};
            const cancellationMap = {};
            
            results.forEach(room => {
                if (room) {
                    room.rates.forEach(rate => {
                        priceMap[rate.uniqueKey] = rate.total;
                        cancellationMap[rate.uniqueKey] = rate.cancellation;
                    });
                }
            });
            
            setConvertedPrices(priceMap);
            setCancellationPrices(cancellationMap);
        };
        
        calculatePrices();
    }, [hotel?.rooms, userData.token, selectedCurrency]);

    const handleBookSubmit = async (rate) => {
        try {
            if (!userData?.token) {
                Swal.fire({
                    title: "Please login first!",
                    icon: "error",
                    draggable: true,
                });
                return;
            }

            // offerKey kontrolü
            const offerKey = rate?.rateKey || rate?.key || rate?.offerKey;
            if (!offerKey) {
                Swal.fire({
                    title: "Error!",
                    text: "Reservation key not found",
                    icon: "error",
                    draggable: true,
                });
                return;
            }

            navigate(`/checkout`, {
                state: {
                    offerKey: String(offerKey),
                    thumbnail: hotel?.thumbnail
                }
            });
        } catch (error) {
            console.error('Error in handleBookSubmit:', error);
            Swal.fire({
                title: "Error",
                text: "Failed to process booking. Please try again.",
                icon: "error",
                draggable: true,
            });
        }
    };

    const getSupplierNumber = (provider) => {
        const mapping = {
            "cornleth": 1,
            "hotelbeds": 2,
            "paximum": 3
        };
        return mapping[provider] || "N/A"; // Eğer eşleşme yoksa 'N/A' yazsın.
    };

    const [occupancies, setOccupancies] = useState([]);

    // URL'den occupancies parametresini parse et
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const occupanciesParam = urlParams.get('occupancies');
        if (occupanciesParam) {
            try {
                const decodedOccupancies = JSON.parse(decodeURIComponent(occupanciesParam));
                setOccupancies(decodedOccupancies);
            } catch (error) {
                console.error('Error parsing occupancies:', error);
                // Varsayılan olarak tek oda
                setOccupancies([{
                    rooms: 1,
                    adults: 2,
                    children: 0,
                    paxes: []
                }]);
            }
        }
    }, []);

    // Oda ekleme fonksiyonu
    const addRoom = () => {
        setOccupancies([...occupancies, {
            rooms: 1,
            adults: 2,
            children: 0,
            paxes: []
        }]);
    };

    // Oda silme fonksiyonu
    const removeRoom = (index) => {
        if (occupancies.length > 1) {
            const newOccupancies = [...occupancies];
            newOccupancies.splice(index, 1);
            setOccupancies(newOccupancies);
        }
    };

    // Oda bilgilerini güncelleme fonksiyonu
    const updateRoom = (index, field, value) => {
        const newOccupancies = [...occupancies];
        newOccupancies[index] = {
            ...newOccupancies[index],
            [field]: value
        };
        setOccupancies(newOccupancies);
    };

    // Çocuk yaşlarını güncelleme fonksiyonu
    const updateChildAges = (roomIndex, childIndex, age) => {
        const newOccupancies = [...occupancies];
        if (!newOccupancies[roomIndex].paxes) {
            newOccupancies[roomIndex].paxes = [];
        }
        newOccupancies[roomIndex].paxes[childIndex] = {
            type: 'CH',
            age: parseInt(age) || 0
        };
        setOccupancies(newOccupancies);
    };

    // Form submit fonksiyonu
    const handleSearchHotel = async (e) => {
        e.preventDefault();
        
        const newParams = new URLSearchParams(window.location.search);
        newParams.set('checkIn', state.checkIn);
        newParams.set('checkOut', state.checkOut);
        newParams.set('occupancies', JSON.stringify(occupancies));
        newParams.set('nationality', urlNation || 'AL');

        const newUrl = `${window.location.pathname}?${newParams.toString()}`;
        window.history.pushState({}, '', newUrl);
        window.location.reload();
    };

    // Gece sayısını hesaplayan fonksiyon
    const calculateNights = (rate) => {
        // Önce rate içindeki nights değerini kontrol et
        if (rate?.nights) {
            return rate.nights;
        }

        // RateKey varsa ondan hesapla
        if (rate?.rateKey) {
            const dates = rate.rateKey.split('|');
            if (dates.length >= 2) {
                const checkIn = new Date(dates[0].replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3'));
                const checkOut = new Date(dates[1].replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3'));
                const diffTime = Math.abs(checkOut - checkIn);
                return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            }
        }

        // URL'deki tarihlerden hesapla
        const storedCheckIn = localStorage.getItem('start_date');
        const storedCheckOut = localStorage.getItem('end_date');
        
        if (storedCheckIn && storedCheckOut) {
            const checkIn = new Date(storedCheckIn);
            const checkOut = new Date(storedCheckOut);
            const diffTime = Math.abs(checkOut - checkIn);
            return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        }

        return 1; // Varsayılan değer
    };

    // Yıldız sayısını hesaplayan fonksiyon
    const getStarCount = (category) => {
        if (!category?.code) return 0;
        const firstChar = category.code.charAt(0);
        return isNaN(firstChar) ? 0 : parseInt(firstChar);
    };

    // formatCancellationDate fonksiyonunu ekleyelim
    const formatCancellationDate = (dateString) => {
        const date = new Date(dateString);
        const hours = date.getHours();
        const minutes = date.getMinutes();
        
        const dateOptions = {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        };

        if (hours === 3 && minutes === 0) {
            return `${new Intl.DateTimeFormat('en-US', dateOptions).format(date)} at 23:59`;
        } else if (hours === 0 && minutes === 0) {
            return new Intl.DateTimeFormat('en-US', dateOptions).format(date);
        } else {
            return `${new Intl.DateTimeFormat('en-US', dateOptions).format(date)} at ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
        }
    };

    const [cartSummary, setCartSummary] = useState({
        totalRooms: 0,
        roomTypes: [],
        items: {},
        quantities: {}
    });

    useEffect(() => {
        // Reset cart summary when page mounts
        setCartSummary({
            totalRooms: 0,
            roomTypes: [],
            items: {},
            quantities: {}
        });

        // Clear localStorage cart
        localStorage.removeItem('cart');

        // Update cart summary when cart changes
        const updateCartSummary = () => {
            const cart = JSON.parse(localStorage.getItem('cart')) || { data: [] };
            const guestSelection = JSON.parse(localStorage.getItem('guest_selection')) || { rooms: [] };
            
            // offerKey bazlı ürün takibi ve miktar hesaplama
            const items = {};
            const quantities = {};
            
            // Önce offerKey'leri grupla ve miktarları hesapla
            cart.data.forEach(item => {
                if (!items[item.offerKey]) {
                    items[item.offerKey] = {
                        ...item,
                        quantity: item.quantity || 1
                    };
                    quantities[item.offerKey] = item.quantity || 1;
                } else {
                    items[item.offerKey].quantity = (items[item.offerKey].quantity || 1) + (item.quantity || 1);
                    quantities[item.offerKey] = (quantities[item.offerKey] || 1) + (item.quantity || 1);
                }
            });

            // Group rooms by occupancy and room name
            const roomTypes = {};
            Object.values(items).forEach(item => {
                const key = `${item.adults}adults-${item.children}children-${item.roomName}`;
                if (!roomTypes[key]) {
                    roomTypes[key] = {
                        adults: item.adults,
                        children: item.children,
                        roomName: item.roomName,
                        count: item.quantity || 1,
                        offerKey: item.offerKey
                    };
                } else {
                    roomTypes[key].count = item.quantity || 1;
                }
            });

            // Toplam oda sayısını hesapla
            const totalRooms = Object.values(items).reduce((total, item) => total + (item.quantity || 1), 0);

            setCartSummary({
                totalRooms: totalRooms,
                roomTypes: Object.values(roomTypes),
                items: items,
                quantities: quantities
            });
        };

        // Listen for cart changes
        window.addEventListener('storage', updateCartSummary);
        return () => window.removeEventListener('storage', updateCartSummary);
    }, []);

    const handleClearCart = async () => {
        const result = await Swal.fire({
            title: 'Clear Cart',
            text: 'Are you sure you want to clear your cart?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, clear it!',
            cancelButtonText: 'Cancel'
        });

        if (result.isConfirmed) {
            localStorage.setItem('cart', JSON.stringify({ data: [] }));
            setCartSummary({ 
                totalRooms: 0, 
                roomTypes: [],
                items: {},
                quantities: {}
            });
            // Update cart count in header
            const headerCart = document.querySelector('.header-cart-count');
            if (headerCart) {
                headerCart.textContent = '0';
            }
            Swal.fire('Cleared!', 'Your cart has been cleared.', 'success');
        }
    };

    const handleProceedToCheckout = async () => {
        const userData = JSON.parse(localStorage.getItem('user_data'));

        if (!userData?.token) {
            Swal.fire({
                title: 'Please Login',
                text: 'You need to login to proceed to checkout',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        if (cartSummary.totalRooms === 0) {
            Swal.fire({
                title: 'Empty Cart',
                text: 'Your cart is empty',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        // Show loading alert
        Swal.fire({
            title: 'Processing...',
            text: 'Adding items to your cart',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            // Her oda tipi için işlem yap
            for (const roomType of cartSummary.roomTypes) {
                // İlk ürünü ekle ve basket_item_id'yi al
                const initialResponse = await axios.post(
                    `${config.API_BASE_URL_V1}basket/add`,
                    {
                        offer_key: roomType.offerKey,
                        type: "hotel"
                    },
                    {
                        headers: {
                            'Authorization': `Bearer ${userData.token}`
                        }
                    }
                );

                if (initialResponse.data.status !== 'success') {
                    throw new Error(`Failed to add item ${roomType.offerKey} to cart`);
                }

                // API yanıtından basket item ID'yi al
                const basketItem = initialResponse.data.data.basket.basketItems[0];
                if (!basketItem || !basketItem.id) {
                    throw new Error('Basket item ID not found in response');
                }

                const basketItemId = basketItem.id;

                // Eğer miktar 1'den fazlaysa, miktarı artır
                if (roomType.count > 1) {
                    for (let i = 1; i < roomType.count; i++) {
                        const plusResponse = await axios.post(
                            `${config.API_BASE_URL_V1}basket/plus-quantity/${basketItemId}`,
                            {},
                            {
                                headers: {
                                    'Authorization': `Bearer ${userData.token}`
                                }
                            }
                        );

                        if (plusResponse.data.status !== 'success') {
                            throw new Error(`Failed to increase quantity for item ${roomType.offerKey}`);
                        }
                    }
                }
            }
            // Clear localStorage cart after successful API calls
            localStorage.removeItem('cart');
            Swal.fire({
                toast: true,
                position: 'top-right',
                title: 'Success!',
                text: 'Your cart has been updated.',
                icon: 'success',
                showConfirmButton: false,
                timer: 2000
            });
            navigate('/cart');
        } catch (error) {
            console.error('Error processing cart:', error);
            Swal.fire({
                title: 'Error!',
                text: error.message || 'Failed to process cart',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
        finally {
            Swal.close();
        }
    };

    if (state.loading) {
        return (
            <div id="loader-wrapper">
                <div id="loader">
                    <span className="loader-line"></span>
                </div>
            </div>
        )
    }

    if (hotelLoading) {
        return (
            <div id="loader-wrapper">
                <div id="loader">
                    <span className="loader-line"></span>
                </div>
            </div>
        )
    }

    if (!isLoaded) {
        return <div>Harita yükleniyor...</div>;
    }

    console.log('Hotel Data:', hotel);

    return (
        <Layout>
            <div className="breadcrumb-bar breadcrumb-bg-01 text-center">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-12">
                            <h2 className="breadcrumb-title mb-2"> {hotel?.name} </h2>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb justify-content-center mb-0">
                                    <li className="breadcrumb-item"><a href="index.html"><i className="isax isax-home5"></i></a></li>
                                    <li className="breadcrumb-item">Hotels</li>
                                    <li className="breadcrumb-item active" aria-current="page">{hotel?.name} </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8">
                            <div className="d-flex align-items-center justify-content-between mb-2 flex-wrap container">
                                <div className="mb-2">
                                    <h4 className="d-flex align-items-center mb-1 flex-wrap" style={{ textTransform: 'capitalize' }}>
                                        {hotel?.name?.toLowerCase()}
                                    </h4>
                                    <div className="d-flex align-items-center flex-wrap">
                                        <p className="fs-14 border-end mb-2 me-3 pe-3">
                                            <i className="isax isax-buildings me-2"></i>
                                            {hotel?.accommodationType?.typeDescription || 'Hotel'}
                                        </p>
                                        <p className="fs-14 border-end mb-2 me-3 pe-3" style={{ textTransform: 'capitalize' }}>
                                            <i className="isax isax-location5 me-2"></i>
                                            {hotel?.country?.description?.content?.toLowerCase()}, {hotel?.city?.content?.toLowerCase()}
                                        </p>
                                        <div className="align-items-center mb-2">
                                            {hotel?.category && (
                                                <div className='d-flex flex-row align-items-center items-center gap-2'>
                                                    <div className='align-items-center'>
                                                        {Array.from({ length: getStarCount(hotel.category) }, (_, index) => (
                                                            <FaStar
                                                                key={index}
                                                                style={{ color: 'orange' }}
                                                                className="text-12"
                                                            />
                                                        ))}
                                                    </div>
                                                    <span className="align-items-center badge badge-warning badge-xs text-gray-9 fs-13 fw-medium me-2 align-items-center">
                                                        {getStarCount(hotel.category)}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="border-bottom mb-4 pb-4">
                                {hotel?.image?.length > 0 && <HotelGallery images={hotel.image} />}
                                <h5 className="fs-18 mb-3">Description</h5>
                                <div>
                                    <p>{hotel?.description || 'No description available'}</p>
                                </div>
                            </div>
                            <HotelAmenities 
                                facilities={hotel?.facilities || []} 
                                showAllFacilities={showAllFacilities} 
                                setShowAllFacilities={setShowAllFacilities} 
                            />

                            {hotel?.facilities?.some(facility => facility.indFee) ? (
                                <div className="border-bottom mb-4 pb-2">
                                    <h5 className="fs-18 mb-3">Additional Charge Facilities</h5>
                                    <div className="row">
                                        {hotel.facilities
                                            .filter(item => item.indFee)
                                            .map((item, index) => (
                                                <div key={index} className="col-sm-4 col-lg-4">
                                                    <div className="d-flex align-items-center mb-3">
                                                        <i className="isax isax-tick-circle me-2"></i>
                                                        <p className="mb-0">{item?.description?.content || 'No description available'}</p>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            ) : null}



                            {
                                hotel?.interestPoints != null &&
                                <>
                                    <div className="border-bottom mb-4 pb-2">
                                        <h5 className="fs-18 mb-3">Interested Points</h5>
                                        <div className="row">
                                            {hotel?.interestPoints?.map((point, index) =>
                                                <div key={index} className="col-sm-4 col-lg-4">
                                                    <div className="d-flex align-items-center mb-3">
                                                        <span className="avatar avatar-md bg-primary-transparent rounded-circle me-2">
                                                            <FaMapPin />
                                                        </span>
                                                        <p className='text-capitalize'> {point.poiName.toLowerCase()} </p>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </>
                            }

                            <div className="border-bottom mb-4 pb-2">
                                <h5 className="fs-18 mb-3">Boards</h5>
                                <div className="row">
                                    {hotel?.boards?.map((item, index) => (
                                        <div key={index} className="col-md-4 col-lg-4">
                                            <div className="d-flex align-items-center mb-3">
                                                <span className="avatar avatar-md bg-primary-transparent rounded-circle me-2">
                                                    <i className="isax isax-verify fs-16"></i>
                                                </span>
                                                <p className='text-capitalize mb-0'> {item?.description?.content?.toLowerCase() || 'No board information available'} </p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                       

                        <div className="col-xl-4 theiaStickySidebar">

                        <div class="card shadow-none">
                            <div class="card-body">
                              
                            <div class="banner-form">
                                <form onSubmit={handleSearchHotel}>
                                    <div class="form-info border-0">
                                        <div class="form-item border rounded p-3 mb-3 w-100">
                                            <label class="form-label fs-14 text-default mb-0">Check In</label>
                                            <input 
                                                type="date" 
                                                name="checkIn" 
                                                class="form-control" 
                                                value={state.checkIn}
                                                onChange={(e) => {
                                                    dispatch({ type: 'SET_CHECK_IN', payload: e.target.value });
                                                    const nextDay = new Date(e.target.value);
                                                    nextDay.setDate(nextDay.getDate() + 1);
                                                    dispatch({ type: 'SET_CHECK_OUT', payload: nextDay.toISOString().split('T')[0] });
                                                }}
                                            />
                                        </div>
                                        <div class="form-item border rounded p-3 mb-3 w-100">
                                            <label class="form-label fs-14 text-default mb-0">Check Out</label>
                                            <input 
                                                type="date" 
                                                name="checkOut" 
                                                class="form-control" 
                                                value={state.checkOut}
                                                min={state.checkIn}
                                                onChange={(e) => dispatch({ type: 'SET_CHECK_OUT', payload: e.target.value })}
                                            />
                                        </div>

                                        {occupancies.map((room, roomIndex) => (
                                            <div key={roomIndex} class="card shadow-none mb-3">
                                                <div class="card-body p-3 pb-0">
                                                    <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-2">
                                                        <h6>Room {roomIndex + 1}</h6>
                                                        {occupancies.length > 1 && (
                                                            <button 
                                                                type="button" 
                                                                class="btn btn-sm btn-outline-danger"
                                                                onClick={() => removeRoom(roomIndex)}
                                                            >
                                                                <i class="isax isax-trash"></i>
                                                            </button>
                                                        )}
                                                    </div>
                                                    <div class="custom-increment">
                                                        <div class="mb-3 d-flex align-items-center justify-content-between">
                                                            <label class="form-label text-gray-9 mb-0">Adults</label>
                                                            <div class="custom-increment">
                                                                <div class="input-group">
                                                                    <span class="input-group-btn float-start">
                                                                        <button 
                                                                            type="button" 
                                                                            class="quantity-left-minus btn btn-light btn-number" 
                                                                            onClick={() => updateRoom(roomIndex, 'adults', Math.max(1, room.adults - 1))}
                                                                        >
                                                                            <span><i class="isax isax-minus"></i></span>
                                                                        </button>
                                                                    </span>
                                                                    <input type="text" class="input-number" value={room.adults} readOnly />
                                                                    <span class="input-group-btn float-end">
                                                                        <button 
                                                                            type="button" 
                                                                            class="quantity-right-plus btn btn-light btn-number"
                                                                            onClick={() => updateRoom(roomIndex, 'adults', room.adults + 1)}
                                                                        >
                                                                            <span><i class="isax isax-add"></i></span>
                                                                        </button>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="mb-3 d-flex align-items-center justify-content-between">
                                                            <label class="form-label text-gray-9 mb-0">Children <span class="text-default fw-normal">( 0-12 Yrs )</span></label>
                                                            <div class="custom-increment">
                                                                <div class="input-group">
                                                                    <span class="input-group-btn float-start">
                                                                        <button 
                                                                            type="button" 
                                                                            class="quantity-left-minus btn btn-light btn-number"
                                                                            onClick={() => updateRoom(roomIndex, 'children', Math.max(0, room.children - 1))}
                                                                        >
                                                                            <span><i class="isax isax-minus"></i></span>
                                                                        </button>
                                                                    </span>
                                                                    <input type="text" class="input-number" value={room.children} readOnly />
                                                                    <span class="input-group-btn float-end">
                                                                        <button 
                                                                            type="button" 
                                                                            class="quantity-right-plus btn btn-light btn-number"
                                                                            onClick={() => updateRoom(roomIndex, 'children', room.children + 1)}
                                                                        >
                                                                            <span><i class="isax isax-add"></i></span>
                                                                        </button>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {room.children > 0 && (
                                                            <div class="mb-3">
                                                                <label class="form-label text-gray-9">Children Ages</label>
                                                                <div class="d-flex flex-wrap gap-2">
                                                                    {[...Array(room.children)].map((_, childIndex) => (
                                                                        <div key={`child_age_${childIndex}`} class="d-flex align-items-center gap-2">
                                                                            <input
                                                                                type="number"
                                                                                class="form-control form-control-sm"
                                                                                min="0"
                                                                                max="12"
                                                                                value={room.paxes[childIndex]?.age || 0}
                                                                                style={{ width: '60px' }}
                                                                                onChange={(e) => updateChildAges(roomIndex, childIndex, e.target.value)}
                                                                            />
                                                                            <span class="small text-muted">years</span>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}

                                        <button 
                                            type="button" 
                                            class="btn btn-outline-primary btn-sm mb-3"
                                            onClick={addRoom}
                                        >
                                            <i class="isax isax-add me-1"></i> Add Room
                                        </button>
                                    </div>
                                    <button type="submit" class="btn btn-primary btn-lg search-btn ms-0 mb-3 w-100 fs-14">Search Rooms</button>
                                </form>
                            </div>
                            </div>
                        </div>

                            <div className="card shadow-none" id="location">
                                <div className="">
                                    <iframe
                                        width="100%"
                                        height="400"
                                        src={`https://www.google.com/maps/embed/v1/place?key=${config.API_KEY}&q=${encodeURIComponent(hotel?.name)}&center=${hotel?.coordinates?.latitude},${hotel?.coordinates?.longitude}&zoom=14`}
                                        frameBorder="0"
                                        allowFullScreen
                                        aria-hidden="false"
                                        tabIndex="0"
                                    ></iframe>
                                </div>

                                <div className="card-body">
                                    <div className="d-flex align-items-center justify-content-between mb-1 flex-wrap">
                                        <p className="d-flex align-items-center mb-3 text-capitalize">
                                            <i className="isax isax-location5 me-2"></i> 
                                            {hotel?.address?.content?.toLowerCase()} - {hotel?.city?.content?.toLowerCase()} / {hotel?.country?.description?.content?.toLowerCase()}
                                        </p>
                                    </div>
                                    <h5 className="fs-18 mb-3">Nearby Landmarks & Visits</h5>

                                    {hotel?.interestPoints?.map((point, index) =>
                                        <p key={index} className="d-flex align-items-center mb-2 text-capitalize"><i className="isax isax-tick-circle me-2"></i> {point.poiName.toLowerCase()} </p>
                                    )}

                                    <p className="d-flex align-items-center mb-2"><i className="isax isax-tick-circle me-2"></i>The
                                        Metropolitan Museum of Art</p>
                                    <p className="d-flex align-items-center mb-0"><i
                                        className="isax isax-tick-circle me-2"></i>Yellowstone National Park</p>
                                </div>
                            </div>

                            {hotel?.terminals?.length > 0 ? <>
                                <div className="card shadow-none">
                                    <div className="card-body pb-0">
                                        <h5 className="fs-18 mb-3">Terminals</h5>
                                        {hotel?.terminals?.map((item, index) =>
                                            <div key={index} className="py-1">
                                                <p className="d-flex align-items-center mb-3"><i
                                                    className="isax isax-airplane text-primary me-2"></i> {item?.name?.content}
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </> : <></>}

                            {hotel?.accommodationType != null ? <>
                                <div className="card shadow-none">
                                    <div className="card-body pb-0">
                                        <h5 className="fs-18 mb-3">Accommodation Type</h5>
                                        <div className="d-flex flex-row align-items-center py-1 gap-2 mb-3">
                                            <FaDotCircle />
                                            <p className="mb-0"> ({hotel?.accommodationType?.code}) - <span className='text-capitalize'> {hotel?.accommodationType?.typeDescription?.toLowerCase()} </span></p>
                                        </div>
                                    </div>
                                </div>
                            </> : <></>}

                            {hotel?.chain?.description?.content != null ? <>
                                <div className="card shadow-none">
                                    <div className="card-body pb-0">
                                        <h5 className="fs-18 mb-3">Chain</h5>
                                        <div className="d-flex flex-row align-items-center py-1 gap-2 mb-3">
                                            <FaDotCircle />
                                            <p className="mb-0"> {hotel?.chain?.description?.content}</p>
                                        </div>
                                    </div>
                                </div>
                            </> : <></>}

                        </div>

                        <div className="border-bottom mb-4 pb-2" id="availability">
                            <h5 className="fs-18 mb-3">Availability</h5>

                            <div className="hotel-list">
                                {!hotel?.rooms ? (
                                    <div className="alert alert-info">
                                        No rooms available at the moment.
                                    </div>
                                ) : (
                                    <div className="row">
                                        {hotel.rooms.map((room, roomIndex) => {
                                            if (!room) return null;
                                            
                                            return (
                                                <div className="col-12 mb-3" key={`room-${roomIndex}-${room.name}`}>
                                                    <div className="room-card" 
                                                         style={{ 
                                                             boxShadow: '0px 2px 8px 0px rgba(194, 194, 194, 0.15)',
                                                             borderRadius: '8px',
                                                             overflow: 'hidden'
                                                         }}>
                                                       
                                                        <div className="room-content p-2">
                                                            {!room.rates || room.rates.length === 0 ? (
                                                                <div className="alert alert-warning mb-0 py-2">
                                                                    No rates available for this room.
                                                                </div>
                                                            ) : (
                                                                <div className="rates-grid">
                                                                    {room.rates.map((rate, rateIndex) => {
                                                                        const nights = calculateNights(rate);
                                                                        const uniqueKey = `${room.code}-${rate.boardCode}-${rate.net}`;
                                                                        const totalPrice = convertedPrices[uniqueKey] || "0.00";
                                                                        const perNightPrice = totalPrice && nights ? (Number(totalPrice) / nights).toFixed(2) : "0.00";
                                                                        
                                                                        return (
                                                                            <BigRateCard
                                                                                key={`rate-${rateIndex}-${rate.boardCode || rateIndex}`}
                                                                                rate={rate}
                                                                                thumbnail={hotel?.thumbnail}
                                                                                roomName={room?.name}
                                                                                checkIn={urlCheckIn}
                                                                                checkOut={urlCheckOut}
                                                                            />
                                                                        );
                                                                    })}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        </div>


                    </div>
                </div>
            </div>

            {/* Fixed Cart Footer */}
            {cartSummary.totalRooms > 0 && (
                <div className="fixed-cart-footer">
                    <div className="cart-summary">
                        <FaShoppingCart className="cart-icon" />
                        <div className="summary-text">
                            <span className="total-rooms">{cartSummary.totalRooms} rooms selected</span>
                            <div className="room-types">
                                {cartSummary.roomTypes.map((type, index) => (
                                    <span key={index} className="room-type">
                                        {type.count} × {type.adults} adults {type.children > 0 ? `+ ${type.children} children` : ''} ({type.roomName})
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="cart-actions">
                        <button className="btn btn-outline-danger" onClick={handleClearCart}>
                            <FaTrash /> Clear Cart
                        </button>
                        <button className="btn btn-primary" onClick={handleProceedToCheckout}>
                            Confirm Cart
                        </button>
                    </div>
                </div>
            )}

            <style jsx>{`
                .fixed-cart-footer {
                    position: fixed;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    background: white;
                    padding: 15px 20px;
                    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    z-index: 1000;
                }

                .cart-summary {
                    display: flex;
                    align-items: center;
                    gap: 15px;
                }

                .cart-icon {
                    font-size: 24px;
                    color: #0d6efd;
                }

                .summary-text {
                    display: flex;
                    flex-direction: column;
                }

                .total-rooms {
                    font-weight: 600;
                    font-size: 16px;
                }

                .room-types {
                    display: flex;
                    gap: 10px;
                    flex-wrap: wrap;
                }

                .room-type {
                    font-size: 14px;
                    color: #666;
                    background: #f8f9fa;
                    padding: 4px 8px;
                    border-radius: 4px;
                }

                .cart-actions {
                    display: flex;
                    gap: 10px;
                }

                .btn-outline-danger {
                    display: flex;
                    align-items: center;
                    gap: 5px;
                }

                @media (max-width: 768px) {
                    .fixed-cart-footer {
                        flex-direction: column;
                        gap: 15px;
                        padding: 10px;
                    }

                    .cart-summary {
                        width: 100%;
                    }

                    .cart-actions {
                        width: 100%;
                        justify-content: space-between;
                    }

                    .room-types {
                        flex-direction: column;
                    }
                }
            `}</style>
        </Layout>
    )
}
